// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ob-1";
export var stateContainer = "_ob-0";